import React from "react";
import ReactGA from "react-ga";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import Configuration, { translations } from "../../../config";

import Icon from "../../../components/Icon";
import { getOrderableQuestionnaires } from "../actions/Questionnaires";
import { registrateUser } from "../../../actions/Users";
import { message } from "../../../actions";

const mapStateToProps = ( state ) =>
{
	return {
		orderableQuestionnaires: state.orderableQuestionnaires
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getOrderableQuestionnaires: () =>
		{
			dispatch( getOrderableQuestionnaires() );
		},
		registrateUser: ( formData ) =>
		{
			return dispatch( registrateUser( formData ) );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class SummaryFields extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = this.props.fieldValues.summary
			? this.props.fieldValues.summary
			: {
				...this.props.state,
				agb_approval: false,
				billing_info: ""
			};
		
		this.handleInformation = this.handleInformation.bind( this );
		this.handleConditions = this.handleConditions.bind( this );
		this.handleCancel = this.handleCancel.bind( this );
		this.handleRegistrateUser = this.handleRegistrateUser.bind( this );
	}
	
	componentDidMount()
	{
		// Hole buchbare Fragebögen
		this.props.getOrderableQuestionnaires();
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( translations.de_DE.routes.registration );
		}
		
	} // function componentDidMount()
	
	handleInformation( a_event )
	{
		this.setState( { billing_info: a_event.target.value } );
		
	} // function handleInformation(...)
	
	handleConditions( a_event )
	{
		this.setState( { agb_approval: !this.state.agb_approval } );
		
	} // function handleConditions(...)
	
	handleCancel( a_event )
	{
		a_event.preventDefault();
		
		this.props.saveValues( {
			agb_approval: this.state.agb_approval,
			billing_info: this.state.billing_info
		}, "summary" );
		
		this.props.previousStep();
		
	} // function handleCancel(...)
	
	handleRegistrateUser( a_event )
	{
		a_event.preventDefault();
		
		if ( !this.state.agb_approval )
		{
			this.props.message( "Bitte akzeptieren Sie unsere AGB.", "warning", 5000 );
			
			return;
		}
		
		// Informationen zwischenspeichern falls etwas fehlschlägt
		if ( !this.props.fieldValues.hasOwnProperty( "summary" ) )
		{
			this.props.saveValues( {
				agb_approval: this.state.agb_approval,
				billing_info: this.state.billing_info
			}, "summary" );
		}
		
		// Zusammenfassungsdaten anhängen
		const formData = Object.assign(
			{},
			this.props.fieldValues,
			/*{
			 article: Object.assign(
			 {},
			 this.props.fieldValues.article,
			 {
			 // Ausgewählte Fragebögen als normales Array übergeben
			 selected_questionnaires: Object.keys( this.props.fieldValues.article.selected_questionnaires )
			 }
			 )
			 },*/
			{
				summary: {
					agb_approval: this.state.agb_approval,
					billing_info: this.state.billing_info
				}
			}
		);
		
		this.props.registrateUser( formData ).then(
			a_result =>
			{
				if ( a_result > 0 )
				{
					this.setState( { order_id: a_result } );
				}
			}
		);
		
	} // function handleRegistrateUser(...)
	
	render()
	{
		const { customer, article, payment } = { ...this.props.fieldValues };
		// const { orderableQuestionnaires } = { ...this.props };
		
		return ( [
				this.state.order_id > 0 &&
				<div className={"col s12 tCenter primary-color white-text"}>
					<h6>Ihre Bestellung war erfolgreich</h6>
					<h3>Vielen Dank für Ihre Bestellung</h3>
					<p>Ihre Bestellnummer lautet<br/><strong>{this.state.order_id}</strong></p>
					<p>In Kürze erhalten Sie von uns Ihre detaillierte Bestellbestätigung per E-Mail und einen Aktivierungslink für Ihren persönlichen Zugang.</p>
					<div className={"col s12 spacer cleared"}/>
				</div>,
				<div className={"col s12 relative summary"}>
					<div className={"col s12 l6 xl8 unset-padding"}>
						<div className={"col s12"}>
							<h6>Rechnungsanschrift</h6>
						</div>
						<div className={"col s12 spacer"}/>
						<div className={"col s12 secondary-color-text"}>
							{customer.organization_name}<br/>
							{customer.sex === "m" ? "Herr" : customer.sex === "w" ? "Frau" : ""} {customer.forename} {customer.surname}<br/>
							{customer.organization_street} {customer.organization_street_number}<br/>
							{customer.organization_postal_code} {customer.organization_city}
							<p><strong>E-Mail:</strong> {customer.email}</p>
						</div>
					</div>
					
					<div className={"col s12 l6 xl4 light-grey right-block unset-radius dashed-block-outer"}>
						<div className={"relative"}>
							<div className={"col s12 dashed-block"}>
								<div className={"col s12 price"}>
									
									<div className={"col s12 unset-padding"}>Laufzeit</div>
									<div className={"col s12 unset-padding"}>
										<span className={"value sub"}>{article.contract_duration}</span>
										<span className={"additional"}> Monate</span>
									</div>
									<div className={"col s12 spacer"}/>
									
									<div className={"col s12 unset-padding"}>Monatliche Grundgebühr</div>
									<div className={"col s12 unset-padding"}>
										<span className={"value"}>
											{( parseFloat( article.summary_price ) ).toLocaleString( Configuration.location, Configuration.priceString )}
										</span>
										<span className={"additional"}> Euro</span><br/>
										<label>Preis (zzgl. 19% USt.)</label>
									</div>
									<div className={"cleared spacer"}/>
									
									<div className={"col s12 unset-padding"}>Zzgl. nutzungsabhängige Kosten pro Recherche</div>
									<div className={"cleared spacer"}/>
									<div className={"cleared spacer"}/>
									
									<div className={"col s12 unset-padding"}>
										<label className={"col s12 unset-padding margin-bottom"}>Bankeinzugskonto</label>
										<div className={"col s12 unset-padding"}>
											<span className={"regular"}>Kontoinhaber: </span>
											{payment.account_owner}
										</div>
										<div className={"col s12 unset-padding"}>
											<span className={"regular"}>IBAN: </span>
											{payment.iban}
										</div>
										<div className={"col s12 unset-padding"}>
											<span className={"regular unset-padding"}>Kreditinstitut: </span>
											{payment.credit_institution}
										</div>
									</div>
									{/*<div className={"col s12 spacer"}/>
									 
									 <div className={"col s12 tRight"}>
									 <h6 className="information primary-color-text unset-padding margin-bottom">Lizenzen</h6>
									 <div className={"additional secondary-color-text"}>
									 {article.questionnaires_count === "0" ? Object.keys( article.selected_questionnaires ).length : article.questionnaires_count} {article.questionnaires_count === "1" ? "Assistent" : "Assistenten"}
									 </div>
									 <div className={"additional secondary-color-text"}>
									 {article.users_count} Benutzer
									 </div>
									 </div>*/}
								</div>
							</div>
						</div>
					</div>
					<div className={"col s12 spacer"}/>
					
					<div className={"col s12 l6 xl8 unset-padding"}>
						<div className={"col s12 xl8"}>
							<label>
								<div className={"form-element-name"}>Ihre persönliche Nachricht an uns</div>
							</label>
							<div className={"col s12 billingInfo light-grey"}>
								<textarea name={"billing_info"} title={"Bearbeitungsinformationen"} maxLength={"255"}
								          defaultValue={this.state.billing_info}
								          onBlur={( a_event ) => this.handleInformation( a_event )}
								          disabled={this.state.order_id > 0 ? "disabled" : ""}/>
							</div>
						</div>
						<div className={"col s12 spacer cleared"}/>
						
						<div className="col s12">
							<label>
								<input name={"agb_approval"}
								       title={"Die AGB akzeptieren"}
								       type={"checkbox"}
								       onClick={( a_event ) => this.handleConditions( a_event )}
								       defaultChecked={this.state.agb_approval} disabled={this.state.order_id > 0 ? "disabled" : ""}/>
								<span><p>Die <NavLink to={"/agb"} target={"_blank"}>AGB</NavLink> von Imera gelesen und akzeptiert.</p></span>
								<span className="form-element-required">*</span>
							</label>
						</div>
						<div className={"col s12 spacer"}/>
						{
							
							this.state.order_id > 0
								? <div className="col s12">
									<NavLink className={"btn secondary-color"} to={"/"}>
										<Icon size={14} iconName={"leave"}/><span>Zurück zur Startseite</span>
									</NavLink>
								</div>
								: <div className="col s12">
									<button className={"secondary-color"} onClick={( a_event ) => this.handleCancel( a_event )}>
										<Icon size={14} iconName={"leave"}/><span>Zurück zur Zahlung</span>
									</button>
									<button onClick={( a_event ) => this.handleRegistrateUser( a_event )}>
										<Icon size={14} iconName={"next"}/><span>Registrieren und kostenpflichtig bestellen</span>
									</button>
								</div>
						}
					</div>
				</div>
			]
		);
		
	} // function render()
	
} // class

SummaryFields = connect(
	mapStateToProps,
	mapDispatchToProps
)( SummaryFields );

export default SummaryFields;
